import { OrderStatus } from "@/modules/salesOrder/enum/OrderStatus";

export const orderStatusColor: Record<string, string> = {
  [OrderStatus.DataIssue]: "error",
  [OrderStatus.Assigned]: "warning",
  [OrderStatus.OnHold]: "info",
  [OrderStatus.Complete]: "success",
};
